import { render, staticRenderFns } from "./ReviewDE.vue?vue&type=template&id=b78c9170"
import script from "./ReviewDE.vue?vue&type=script&lang=js"
export * from "./ReviewDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports